import { Component, Input } from '@angular/core';
import { Job } from '../services/position-services';

@Component({
  selector: 'tu-position-info',
  templateUrl: './position-info.component.html'
})
export default class PositionInfoComponent {
  @Input() position: Job;
}



// WEBPACK FOOTER //
// ./src/app/position-info/position-info.component.ts